import React from 'react';

export function SpinnerOnTop() {
  return(
    <div className="spinner-grow spinner-grow-sm" role="status">
      <span className="sr-only">Loading...</span>
    </div>
  );
}
